export enum DynamicTimetableCellTypeDTO {
  ROUTE_NUMBER = 'ROUTE_NUMBER',
  DESTINATION = 'DESTINATION',
  DIRECTION = 'DIRECTION',
  SCHEDULED_TIME = 'SCHEDULED_TIME',
  DEPARTURE_TIME = 'DEPARTURE_TIME',
  DELAY = 'DELAY',
  ICON_GPS_TIME = 'ICON_GPS_TIME',
  ICON_LOW_FLOOR = 'ICON_LOW_FLOOR',
  ICON_VEHICLE_TYPE = 'ICON_VEHICLE_TYPE',
  IMAGE = 'IMAGE',
  TEXT_CONSTANT = 'TEXT_CONSTANT',
}
